module.exports = "/images/electrum-logo@2x.png?a2deb2535943ba93f23ac1174c2d100d";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/electrum-logo@2x.png
// module id = cDRE
// module chunks = 0